// Module
var code = `<div class="saved-orders-panel">
    <div class="saved-orders-panel-container-top">
        <terceraButton name="add" SVG="true" terceraButtonStyle="image-button-plain" on-btnClick="onAddButtonClick" enabled="{{isEnabledAddButton}}" visible="{{isToolbarVisible}}"/>
        <terceraEditableListComboBox name="editableCB" 
                                     isAllowRename="true" 
                                     isAllowRemove="true" 
                                     createNewTooltip="editableComboBox.CreateNewOrders.tooltip"
                                     renameTooltip="panel.menu.renameList"
                                     removeTooltip="panel.menu.removeList"
                                     items="{{items}}" 
                                     storageName="savedOrdersSheets" 
                                     tooltip="{{editableCBtooltip}}" 
                                     enabled="{{isEnabledCombobox}}" 
                                     visible="{{isToolbarVisible}}" />
        <terceraButton name="placeButton" terceraButtonStyle="js-button-blue style-width-85" text="{{placeButtonText}}" on-btnClick="onPlaceButtonClick" enabled="{{isEnabledPlaceButton}}" visible="{{isToolbarVisible}}"/>
    </div>

    <div class="saved-orders-panel-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;